<template>
  <v-form ref="patientStepOneForm" v-model="valid">
    <v-container>
      <v-row>
        <v-col cols="12" md="5">
          <p class="font-weight-medium mb-0">
            {{ $vuetify.lang.t("$vuetify.main.patientReg.stepOne.yourName") }}
          </p>
          <p class="text--gotham-book text-gray">
            {{ $vuetify.lang.t("$vuetify.main.patientReg.stepOne.nameDesk") }}
          </p>
        </v-col>
        <v-col cols="12" md="4" class="pt-1">
          <v-text-field
            v-model="patientName"
            :rules="patientNameRules"
            :label="
              $vuetify.lang.t(`$vuetify.main.patientReg.stepOne.nameLabel`)
            "
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="5">
          <p class="font-weight-medium mb-0">
            {{ $vuetify.lang.t("$vuetify.main.patientReg.stepOne.yourAge") }}
          </p>
          <p class="text--gotham-book text-gray">
            {{ $vuetify.lang.t("$vuetify.main.patientReg.stepOne.ageDesk") }}
          </p>
        </v-col>
        <v-col cols="12" md="2" class="pt-1">
          <v-text-field
            v-model="patientAge"
            :rules="patientAgeRules"
            :label="
              $vuetify.lang.t(`$vuetify.main.patientReg.stepOne.ageLabel`)
            "
            required
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- <v-row>
        <v-col cols="12" md="5">
          <p class="font-weight-medium mb-0">
            {{
              $vuetify.lang.t(
                "$vuetify.main.patientReg.stepOne.consultationType"
              )
            }}
          </p>
        </v-col>
        <v-col cols="12" md="2" class="pt-0 mt-0">
          <v-select
            v-model="consultationType"
            :items="consultationTypeList"
            item-value="val"
            item-text="title"
            dense
            class="pt-1 mt-0"
          ></v-select>
        </v-col>
      </v-row> -->
      <v-divider class="mt-5 mb-5"></v-divider>

      <v-row>
        <v-col cols="12" md="5">
          <p class="font-weight-medium mt-5">E-mail</p>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="patientEmail"
            :rules="patientEmailRules"
            label="E-mail"
            required
            class="mt-0 pt-2"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row v-if="needsPhone">
        <v-col cols="12" md="5">
          <p class="font-weight-medium mt-5">Телефон</p>
        </v-col>
        <v-col cols="12" md="7" lg="5">
          <vue-phone-number-input
            v-model="unverifiedPhone"
            :default-country-code="defaultCountry"
            :preferred-countries="countriesList"
            :loader="hasLoaderActive"
            :error="hasErrorActive"
            :translations="translations"
            @update="updatedPhone"
            show-code-on-list
            :required="true"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="5">
          <p class="font-weight-medium mt-5">
            {{ $vuetify.lang.t("$vuetify.main.patientReg.stepOne.timeZone") }}
          </p>
        </v-col>
        <v-col cols="12" md="4">
          <timeZoneInput @new-time-zone="setTimeZone"></timeZoneInput>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import TimeZoneInput from "@/components/UI/timeZoneInput";
export default {
  name: "stepOne",
  components: { TimeZoneInput },
  data() {
    return {
      userData: null,
      defaultCountry: "",
      countriesList: ["UA", "RU", "BY", "MD"],
      hasLoaderActive: false,
      hasErrorActive: false,
      unverifiedPhone: "",
      valid: false,
      patientName: "",
      patientAge: "",
      patientEmail: "",
      therapyExperience: "",
      // consultationType: "",
      timeZone: "",
      patientNameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientNameRules"
          ),
      ],
      patientAgeRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientAgeRules1"
          ),
        (v) =>
          +v > 16 ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientAgeRules2"
          ),
      ],
      patientEmailRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientEmailRules1"
          ),
        (v) =>
          /.+@.+/.test(v) ||
          this.$vuetify.lang.t(
            "$vuetify.main.patientReg.stepOne.patientEmailRules2"
          ),
      ],
    };
  },
  created() {
    this.$eventHub.$on("patient-step-one-form_validate-form", this.validate);
  },
  beforeDestroy() {
    this.$eventHub.$off("patient-step-one-form_validate-form", this.validate);
  },
  computed: {
    ...mapGetters({
      user: "user/getUser",
    }),
    translations() {
      return {
        countrySelectorLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorLabel"
        ),
        countrySelectorError: this.$vuetify.lang.t(
          "$vuetify.view.signIn.countrySelectorError"
        ),
        phoneNumberLabel: this.$vuetify.lang.t(
          "$vuetify.view.signIn.phoneNumberLabel"
        ),
        example: this.$vuetify.lang.t("$vuetify.view.signIn.example"),
      };
    },
    needsPhone() {
      let currentLoginProvider = this.$store.getters['user/getLoginProvider'];
      if (currentLoginProvider.provider_id != null && 
        currentLoginProvider.provider_id.trim() !== ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    therapyExperienceList() {
      return [
        {
          title: this.$vuetify.lang.t("$vuetify.main.patientReg.stepOne.yes"),
          val: 1,
        },
        {
          title: this.$vuetify.lang.t("$vuetify.main.patientReg.stepOne.no"),
          val: 0,
        },
      ];
    },
    // consultationTypeList() {
    //   return [
    //     {
    //       title: this.$vuetify.lang.t("$vuetify.main.patientReg.stepOne.single"),
    //       val: 1,
    //     },
    //     {
    //       title: this.$vuetify.lang.t("$vuetify.main.patientReg.stepOne.family"),
    //       val: 0,
    //     },
    //   ];
    // },
  },
  watch: {
    userData() {
      let countryCode = this.userData.countryCode;
      let nationalNumber = this.userData.nationalNumber;
      switch (countryCode) {
        case "UA":
          if (nationalNumber) {
            if (Array.from(nationalNumber).length > 9) {
              this.hasErrorActive = true;
              this.userData.isValid = false;
            } else {
              this.hasErrorActive = false;
            }
          }
      }
    },
  },
  methods: {
    updatedPhone(data) {
      this.userData = data;
    },
    setTimeZone(val) {
      this.timeZone = val;
    },
    validate() {
      this.$refs.patientStepOneForm.validate();

      if (this.needsPhone && (!this.userData || (this.userData && !this.userData.isValid))) {
        this.hasErrorActive = true;
      } else {
        if (this.valid) {
          if (this.needsPhone) {
            this.$store.commit("user/SET_USER_UNVERIFIED_PHONE", {
              phone: this.userData.formattedNumber,
              code: this.userData.countryCode,
            });
          }

          this.$store.dispatch(
            "user/setPatientQuestionnaireName",
            this.patientName
          );
          this.$store.dispatch(
            "user/setPatientQuestionnaireAge",
            this.patientAge
          );
          // this.$store.dispatch(
          //   "user/setPatientQuestionnaireConsultationType",
          //   this.consultationType 
          // );
          this.$store.dispatch("user/setEmail", this.patientEmail);
          this.$store.dispatch("user/setUserTimezone", this.timeZone);

          this.$eventHub.$emit("switch-patient-registration-tab", 2);
        }
      }
    },
  },
};
</script>
